import { useEffect, useState } from 'react';
import { useLocation } from 'react-router';
import pkg from '../../package.json';

export const useVersionCheck = (): { hasNewVersion: boolean } => {
  const [hasNewVersion, setHasNewVersion] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => {
    if (hasNewVersion) return;
    if (import.meta.env.DEV) return;

    let cancelled = false;

    const check = () => {
      fetch('/version.json', { cache: 'no-store' })
        .then((res) => (res.ok ? res.json() : null))
        .then((data: { version?: string } | null) => {
          if (cancelled || !data?.version) return;
          if (data.version !== pkg.version) {
            setHasNewVersion(true);
          }
        })
        .catch(() => {});
    };

    check();

    const onVisibility = () => {
      if (document.visibilityState === 'visible') check();
    };
    document.addEventListener('visibilitychange', onVisibility);

    return () => {
      cancelled = true;
      document.removeEventListener('visibilitychange', onVisibility);
    };
  }, [pathname, hasNewVersion]);

  return { hasNewVersion };
};
